<template>
  <div>
    <div class="container" style="width: 1300px; margin: 6px auto">
      <iframe
        ref="iframe"
        src="http://119.45.200.53:4567/"
        width="100%"
        frameborder="0"
        height="800px"
        style="border-radius: 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background-color: #fff;"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Genomes",
  components: {  },
  data() {
    return {
      textarea:
        ">example1\nATGACAGAATATGTAGGTGTATTGTTGTATATTGCTATTGCAGTAGGTCTTGGTATTGTTATTCTTTTTAGGTCTTATAAAGTAAGGCCTCGTCGATTGGATTTGGAAAAAGCAACTGCCTATGAATGTGGTTTTGAACCCTTTGGAGAAGCTCGATCCCCTTTTGATATTGGTTTTTATTTGGTCGCGATTCTTTTCTAGATTTTCGATATCGAGGTCGCATTTTTGCTCCCATGGGTACTTGGTGGAATTAGTACAGGCTCCAGTGGATTTTTTGCTTTTCTCCTTTTCTAGGTTGTCCTTACCATTGGCTTTGTTTTTGAATGGCAAAAAGGTGCTTTGGAATGGAGTTCA\n>example2\nATGAAAGATACGTCCAATAAATGGTATAAATAGTTTATTCGATGGTTTTGTAGTACAAACGCTAAAGACATTGGAATGATGTATTAGGTCTTTGCAAGGTGGTCTGGTGTAATTGCTACTACAATGAGTTTGTTGATTCGAATGGAATAGAGGAGTACAGGTCCTGGTATTTTGGCAGGAAATGGACAACTTTATAATGTGTAGATTACAGCACACGGATTGTTGATGTTGTTCTTTGTTGTAATGCCTGCATAGATGGGTGGATTCGGTAACTGGCTTGTTCCGGTTATGATTGGAAGGCCAGACATGGCATTTCCTCGAATGAACAACATTAGTTTTTGGGTTTTGCCTATGGGAATGATCTTGTTGTTGTTGAGTGCTTTGGTTGAGCAAGGACCTGGAGTAGGATGGACAGCATATCCTCCTCTTAGTAGTGCTTTGAGTCACTCTGGGGCTTCTGTTGACTTGGCAATTTTCAGTTTGCATATTATTGGTATTGGAAGTATTTAGGGATCTATTAATTTCTAGGTAACTGTTGCAAACATGCGTGCTCAAGGAATGACTTTGTATCGAGTACCTCTCTTTGTATGGGCATTGTGCTTTGTAAGTATTTTGTTGATTGGAAGTCTTCCTGTATTTGCAGCAGGATTGACAATGCTTTAGACAGACCGTAATTTCAACACAAGCTTTTTCTAGCCTGCTGGTGGAGGTGATGTTGTTTAGTATCAGCACTTGTTCTGGTTTTTTGGTCACCCTGAAGTATATGTTTTGATCTTGCCTGCGTTTGGTATTGTTTCTCATGTATAGAGCTTTTTTGCACGTAAACCAGTATTTGGTTATGTTGGAATGGTAAATGCAATGGGTGCAATTGCCGTGTAGGGGTTCTAGGTGTGGGCTCACCACATGTACACTGTAGGATTGGACGTTGATACACGTAGGTACTTTACTAGTGCAACAATGATTATTGCAGTTCCTACTGGAATTAAAATTTTCAGTTGGCTTAGGACTTTGTATGGGGGATCCCTTTGGCTTACAACTCCAATGTTGTTTGCTTTGGGCTTCTTGGTATTGTTTACCATTGGAGGTCTTACAGGAATTGTATTGGCAAATGCTGGAGTTGATGTTGCATTGCACGATACTTATTATGTAGTAAGGCACTTCCACTATGTATTGAGCATGGGAGCTGTTTTTGGAATTTTCAGGGCATTTTATTTCTGGGTTAGCAAGCTTACCGGTTGCCAATACCCTGAGCACCATGGACAAAGGCATTTCTTCTTGTTTTTCTTGGGAGTGAACCTTACTTTCTTCCCACAACACTTCCTCGGGCTTGCTGGTATGCCACGTCGTTACCTTGACTATCCAGATGCATTTTTGGGGTGGAACGTGGTAAGTAGTTATGGTTCTTACTAGAGCGCAATTAGTTTTGTATACTTTTTCTATATCGTATATTTGACACTTGCTTATGGTCCAAAATGTGCTAATAACCCATGGTCTGACCAACAAGATAGCACTGCGGGTGGTATTGAATTTGTTCTACCAAGCCCTCCTGCTTATCACACATTCGGTGACCAACTTCCTGTAATTCGTCCTACACCTCAATAGGTTTCA",
      parameters: "",
      nuclDatabase: [],
      protDatabase: [],
      textMethod: "",
      /*用于nucl多选框*/
      nuclCheckAll: false,
      nuclIsIndeterminate: false,
      checkedNuclDatabase: [],
      /*用于prot多选框*/
      protCheckAll: false,
      protIsIndeterminate: false,
      checkedProtDatabase: [],
      advanced: "-evalue 1e-5",
      drawer: false,
      animateOut: false,
      animateshake: true,
    };
  },
  created() {
    this.loadDatabases();
  },
  methods: {
    async loadDatabases() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get(
          "/api/sequenserver/searchdata.json"
        );
        console.log(res);
        for (var i = 0; i < res.database.length; i++) {
          if (res.database[i].type === "nucleotide") {
            this.nuclDatabase.push(res.database[i]);
          } else if (res.database[i].type === "protein") {
            this.protDatabase.push(res.database[i]);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async submit() {
      // 调用获取信息的api请求 , 并解构出data, 重命名为res
      if (this.status) {
        if (this.parameters != "") this.advanced = this.parameters;
        var that = this;
        var jobID = "";
        var database = [];
        if (this.checkedNuclDatabase.length == 0) {
          database = this.checkedProtDatabase;
        } else {
          database = this.checkedNuclDatabase;
        }
        await this.$axios
          .post(
            "/api/sequenserver/submit/",
            that.$qs.stringify(
              {
                method: this.method.toLowerCase(),
                sequence: this.textarea,
                "databases[]": database,
                advanced: this.advanced,
              },
              { arrayFormat: "repeat" }
            )
          )
          .then((response) => {
            console.log(response.request.responseURL);
            // 在这里处理返回的响应
            const url = response.request.responseURL;
            jobID = url.replace(
              "http://" +
              this.$store.state.baseurl +
              ":10019/api/sequenserver/submit",
              ""
            );
            sessionStorage.setItem("jobID", jobID);
          })
          .catch((error) => {
            console.log(error);
          });

        console.log(this.$store.state.SSResult_active);
        this.$router.push({ name: "SSResult" });
      }
    },
    handleNuclCheckAllChange(val) {
      this.checkedNuclDatabase = [];
      if (val) {
        for (var i = 0; i < this.nuclDatabase.length; i++)
          this.checkedNuclDatabase.push(this.nuclDatabase[i].id);
      } else {
        this.checkedNuclDatabase = [];
      }
      this.nuclIsIndeterminate = false;
    },
    nuclHandleCheckedDatabasesChange(value) {
      let checkedCount = value.length;
      this.nuclCheckAll = checkedCount === this.nuclDatabase.length;
      this.nuclIsIndeterminate =
        checkedCount > 0 && checkedCount < this.nuclDatabase.length;
      console.log(this.checkedNuclDatabase);
      console.log(this.checkedProtDatabase);
    },
    handleProtCheckAllChange(val) {
      this.checkedProtDatabase = [];
      if (val) {
        for (var i = 0; i < this.protDatabase.length; i++)
          this.checkedProtDatabase.push(this.protDatabase[i].id);
      } else {
        this.checkedProtDatabase = [];
      }
      this.protIsIndeterminate = false;
    },
    protHandleCheckedDatabasesChange(value) {
      let checkedCount = value.length;
      this.protCheckAll = checkedCount === this.protDatabase.length;
      this.protIsIndeterminate =
        checkedCount > 0 && checkedCount < this.protDatabase.length;
    },
    handleCommand(item) {
      //选择BLAST方法
      this.textMethod = item;
    },
  },
  computed: {
    status() {
      if (
        this.textarea &&
        (this.checkedNuclDatabase.length || this.checkedProtDatabase.length)
      ) {
        return true;
      } else {
        return false;
      }
    },
    method() {
      if (!this.status) {
        return "BLAST";
      } else if (this.checkedNuclDatabase.length) {
        if (
          !this.textMethod ||
          this.textMethod == "BLASTP" ||
          this.textMethod == "BLASTX"
        ) {
          return "BLASTN";
        } else {
          return this.textMethod;
        }
      } else {
        if (
          !this.textMethod ||
          this.textMethod == "TBLASTN" ||
          this.textMethod == "BLASTN" ||
          this.textMethod == "TBLASTX"
        ) {
          return "BLASTP";
        } else {
          return this.textMethod;
        }
      }
    },
    methods() {
      if (
        this.method == "TBLASTN" ||
        this.method == "BLASTN" ||
        this.method == "TBLASTX"
      ) {
        return ["TBLASTN", "BLASTN", "TBLASTX"];
      } else if (this.method == "BLASTP" || this.method == "BLASTX") {
        return ["BLASTP", "BLASTX"];
      } else {
        return [];
      }
    },
  },
  watch: {
    status(newValue) {
      if (newValue == true) {
        // 当盒子类名发生变化时，添加出场动画
        this.animateOut = true;
        this.animateshake = false;

        setTimeout(() => {
          this.animateshake = true;
        }, 10);
        setTimeout(() => {
          this.animateOut = false;
        }, 1000); // 假设动画持续 1 秒钟
      }
    },
  },
};
</script>
<style scoped>
.background {
  position: fixed;
  z-index: -1;
  left: 0;
  top: 0;
  transition: all 0.5s;
  width: 100%;
}
.background .glass {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 1950px;
  /* 模糊大小就是靠的blur这个函数中的数值大小 */
  /* backdrop-filter: blur(1px); */
  transition: all linear 0.5s;
}
.background img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.container {
  display: flex;
}

.right {
  background-color: white;
  width: 400px;
  text-align: center;
  border-radius: 0 5px 5px 0;
}

.BLAST_inactive {
  background: #a37746;
  width: 75%;
  margin: 50px auto 0 auto;
  height: 40px;
  background-size: 400%;
  display: flex;
  border-radius: 5px;
  /* pointer-events: none; */
  cursor: not-allowed;
  padding-left: 20px;
}

.BLAST_active {
  background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
  width: 80%;
  margin: 50px auto 0 auto;
  height: 40px;
  background-size: 400%;
  display: flex;
  border-radius: 5px;
  cursor: pointer;
}

.BLAST_active:hover {
  animation: sun 15s infinite;
  box-shadow: 1px 0px 2px 1px rgb(126, 127, 127);
}

@keyframes sun {
  100% {
    background-position: -400% 0;
  }
}

.databases {
  width: 90%;
  height: 180px;
  margin: auto;
  margin-top: 20px;
}

.submit {
  padding-top: 3px;
  width: 280px;
  font-size: 24px;
  color: white;
}

.el-dropdown-link {
  padding-top: 4px;
  width: 50px;
  font-size: 24px;
  cursor: pointer;
  background-color: #03a9f4;
  border-radius: 0 5px 5px 0;
}

.el-dropdown-link_inactive {
  padding-top: 4px;
  width: 50px;
  font-size: 24px;
  cursor: pointer;
  background-color: #926837;
  border-radius: 0 5px 5px 0;
  cursor: not-allowed;
}

.el-dropdown-link:hover {
  background-color: rgb(42, 133, 212);
}

.shake-x-custom {
  animation-duration: 0.2s;
  /* 调整抖动速度 */
  transform-origin: center;
  /* 设置变形原点为元素中心 */
  animation-name: shakeXCustom;
  animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  animation-iteration-count: infinite;
}

@keyframes shakeXCustom {
  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-3px) scaleX(1);
    /* 调整抖动幅度 */
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(3px) scaleX(1);
    /* 调整抖动幅度 */
  }
}
</style>
